/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I find a number when I know a percentage of it?`)
};

const es_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo encuentro un número si conozco un porcentaje de él?`)
};

const de_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie finde ich eine Zahl, wenn ich einen Prozentsatz davon kenne?`)
};

const nl_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe vind ik een getal als ik een percentage ervan ken?`)
};

const fr_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment trouver un nombre quand on connaît un pourcentage de celui-ci ?`)
};

const it_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come trovo un numero se conosco una percentuale di esso?`)
};

const pt_br2_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro um número quando sei uma porcentagem dele?`)
};

const pt_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro um número quando conheço uma percentagem dele?`)
};

const ja_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ある数のパーセントが分かっているとき、元の数を求めるには？`)
};

const zh_pct_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已知一个数的某个百分比，如何求出这个数？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_faq3_q", locale)
	if (locale === "en") return en_pct_hub_faq3_q(inputs)
	if (locale === "es") return es_pct_hub_faq3_q(inputs)
	if (locale === "de") return de_pct_hub_faq3_q(inputs)
	if (locale === "nl") return nl_pct_hub_faq3_q(inputs)
	if (locale === "fr") return fr_pct_hub_faq3_q(inputs)
	if (locale === "it") return it_pct_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_faq3_q(inputs)
	if (locale === "pt") return pt_pct_hub_faq3_q(inputs)
	if (locale === "ja") return ja_pct_hub_faq3_q(inputs)
	return zh_pct_hub_faq3_q(inputs)
};